export default {
  locale: "en",
  name: "Price Feed",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      { fieldName: "startDate", displayName: "Start Date" },
      { fieldName: "endDate", displayName: "End Date" },
    ],
  },
};
